import styles from './DelegatedScreen.module.css';

// Pantalla del propietario que dio poder por TODAS sus unidades en la asamblea
// en curso: su representante asiste y vota por él, así que no se le pide
// confirmar asistencia ni votar (antes quedaba en un círculo de "confirma" /
// "vota" que el servidor ya no le aceptaba).
// En asambleas virtuales/híbridas puede entrar a Zoom como oyente (escuchar,
// pedir la palabra): eso no marca asistencia ni lo deja votar, porque sus
// unidades las cuenta y vota el representante.
export default function DelegatedScreen({ assembly, delegated, onJoinMeeting }) {
  const hayReunion = ['virtual', 'hybrid'].includes(assembly.assembly_model) && assembly.zoom_meeting_number;
  const iniciada   = !!assembly.meeting_started;
  return (
    <div className={styles.pantalla}>
      <div className={styles.heroe}>
        <div className={styles.heroeCirculo} />
        <div className={styles.heroeContenido}>
          <div className={styles.heroeIcono}>
            <i className={`fas fa-file-signature ${styles.heroeGlifo}`} />
          </div>
          <div className={styles.heroeChip}>
            <i className={`fas fa-circle ${styles.heroeChipPunto}`} />Asamblea en curso
          </div>
          <h2 className={styles.heroeTitulo}>
            {assembly.property?.name}
          </h2>
          <p className={styles.heroeSubtitulo}>
            Asamblea #{assembly.number_assembly}
            {assembly.assembly_type ? ` · ${assembly.assembly_type}` : ''}
          </p>
          {hayReunion && (
            <div className={styles.reunion}>
              <button
                onClick={() => iniciada && onJoinMeeting && onJoinMeeting()}
                disabled={!iniciada}
                className={`${styles.botonReunion} ${iniciada ? styles.botonReunionActivo : ''}`}>
                <i className={`fas fa-video ${iniciada ? styles.videoActivo : styles.videoApagado}`} />
                {iniciada ? 'Unirse a la reunión virtual' : 'Reunión no iniciada aún'}
              </button>
              <span className={styles.reunionNota}>
                {iniciada
                  ? 'Puedes escuchar y pedir la palabra; el voto lo hace tu representante.'
                  : 'Disponible cuando el administrador inicie la reunión'}
              </span>
            </div>
          )}
        </div>
      </div>

      <div className={`card ${styles.tarjeta}`}>
        <h3 className={styles.subtitulo}>
          Diste poder para esta asamblea
        </h3>
        <p className={styles.parrafo}>
          Tu representante asiste y vota en tu nombre. No necesitas confirmar asistencia ni votar.
        </p>
        <div className={styles.listaRepresentantes}>
          {delegated.map((d, i) => (
            <div key={i} className={styles.representante}>
              <i className={`fas fa-user-friends ${styles.representanteIcono}`} />
              <div>
                <div className={styles.representanteNombre}>{d.rep_nombre}</div>
                <div className={styles.representanteDetalle}>
                  {d.rep_es_externo ? 'Persona externa' : 'Propietario del conjunto'} ·{' '}
                  Unidad{d.unidades.length > 1 ? 'es' : ''} {d.unidades.join(', ')}
                </div>
              </div>
            </div>
          ))}
        </div>
        <p className={styles.notaFinal}>
          Si quieres participar tú mismo, pídele a la administración que quite el poder antes de que se vote.
        </p>
      </div>
    </div>
  );
}
